<template>
    <div class="animated fadeIn pt-3">
        <b-row>
            <b-col>
                <b-card no-body class="material" >
                    <div slot="header">
                        <strong>{{ titleCard }}</strong>
                        <div v-if="inConstruction" class="card-header-actions">
                            <b-link  class="card-header-action" @click="onEdit" >
                                <font-awesome-icon icon="edit" /> Seguir editando
                            </b-link>
                        </div>
                        <div v-else class="card-header-actions">
                            <b-link class="card-header-action" @click="$router.go(-1)" >
                                <i class="icon-action-undo"></i> Regresar
                            </b-link>
                        </div>
                    </div>
                    <!--
                    <b-container v-if="flagContent" class="pb-5"  v-bind:style="{ backgroundColor: material.info.color}">
                    -->
                    <!--<b-container v-if="flagContent" class="pb-5"   :style="{ background: `hsla(${material.info.color.hue}deg, 80%, 60%, 1)` }">-->
                    <b-container v-if="flagContent" class="pb-5">
                        <b-row ref="contenedorMaterialData">
                            <slot v-if="material.info">
                                <b-col cols="12" class="title display-4" v-html="material.info.title"></b-col>
                                <b-col cols="12" class="desc" v-html="material.info.description"></b-col>
                            </slot>
                        </b-row>
                        <template v-if="!isLoad">
                        <component v-for="el in material.content" :key="el.index" :is="el.tag" v-bind="{data: el}"></component>
                        </template>
                        <h3 v-if="isLoad" style="text-align: center;">Cargando material</h3>
                    </b-container>
                    <b-container v-else>
                        <h1 class="text-center display-4 mt-5 mb-5 text-secondary">
                            <i class="icon-ghost icons"></i>
                            Sin contenido
                        </h1>
                    </b-container>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<style lang="scss" scoped>
    .card-header-action:hover{
        color: #e3f9ff;
    }
//TODO: mejorar el visor
</style>

<script>
import Recurso from './Recurso';
import Parrafo from './Parrafo';
import Separator from './Separator';
import Tabla from './Tabla';
import Columnas from './Columnas';
import QuizContent from './QuizContent';
import RelacionarContent from './RelacionarContent';
import FlashCards from './FlashCards';
import OrdenaFrase from './OrdenaFrase';
import Sopa from './Sopa';
import HangMan from './HangMan';
import Animales from './Animales';
import Loteria from './Loteria';
import toggleClasses from '@coreui/vue/src/shared/toggle-classes';
import CompletarFrase from './CompletarFrase';
import Memorama from './Memorama';
import Subtitulo from './Subtitulo';
import Crucigrama from './Crucigrama';
import Dot from './Dot';

export default {
    name: 'preview',
    components: {
        Recurso,
        Parrafo,
        Tabla,
        Separator,
        Columnas,
        QuizContent,
        RelacionarContent,
        FlashCards,
        OrdenaFrase,
        Sopa,
        Animales,
        Loteria,
        HangMan,
        CompletarFrase,
        Memorama,
        Subtitulo,
        Crucigrama,
        Dot
    },
    data(){
        return{
            flagContent:true,
            isLoad: true
        }
    },
    props: {
        material: {
            type:Object,
            default: () => { return {} }
        },
        titleCard: {
            type:String,
            default: 'Vista previa'
        }
    },
    methods: {
        onEdit() {
            //this.$store.dispatch('constructor/deactivePreview');
            let body = document.getElementsByTagName('body');
            //body[0].classList.add("aside-menu-lg-show");
            body[0].classList.add("sidebar-lg-show");
            body[0].classList.add("aside-menu-show");
            this.$router.push({name: 'Nuevo'});
        }
    },
    created() {
        console.log(this.material);
        //if(!this.material.content.length && !this.material.info.title && !this.material.info.desc) this.flagContent = false;
        console.log(this.inConstruction);
    },
    mounted(){
        setTimeout(() => this.isLoad = false, 1000);
    },
    computed: {
        inConstruction: function() {return this.$store.getters['constructor/inConstruction']; }
    },
};
</script>